import { alpha, Box, Divider, styled, Typography } from '@mui/material';
import { MediaQueryProps } from './types';

export const LandingPageWrapper = styled(Box)`
  overflow-y: auto;
  height: calc(100vh - 118px);
  margin-top: 16px;
  position: fixed;
  box-sizing: revert;
  background-color: ${({ theme }) => alpha(theme.palette.background.paper, 0.95)};
`;

export const LandingPageDivider = styled(Divider)`
  padding-top: 2rem;
`;

export const LandingPageTopContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['ismobile', 'islaptop', 'iswidescreen'].includes(prop),
})<MediaQueryProps>`
  display: flex;
  flex-direction: ${({ ismobile }) => (ismobile ? 'column' : 'row')};
  padding: ${({ ismobile, islaptop, iswidescreen }) => {
    if (ismobile) return '40px';
    if (islaptop) return '40px 10%';
    if (iswidescreen) return '40px 15%';
    return '40px 10%';
  }};
  gap: ${({ iswidescreen }) => (iswidescreen ? '120px' : '80px')};
`;

export const LandingPageTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: 700;
  font-size: 20px;
  padding-bottom: 30px;
`;

export const RegisteredMark = styled('span')`
  font-size: 0.6em;
  vertical-align: super;
`;
